import { Keys, Resource, Scene } from "excalibur";
import { Player } from "../../player";
import { OpenHive } from "../../actors/openHive";
import { hiveState, inventoryState } from "../../state/stateManager";
import {
  addExperience,
  checkFirstHarvest,
  checkHarvestFrameAmount,
  createGainedItem,
  sendAlert,
} from "../../utils";
import { goToScene } from "../../main";
import { Resources } from "../../Resources";

export default class HarvestMenu extends Scene {
  constructor() {
    super();
    const player = new Player(350, 170, () => {
      this.setPlayerAnim(false);
    });
    this.player = player;

    this.player.z = 3;
    this.player.cutScene = true;

    this.activeItem = 0;
    this.selected = null;
    this.menuItems = 2;
    this.playerAnim = false;
  }
  setPlayerAnim(set) {
    console.log("setting playerAnim: ", set);
    this.playerAnim = set;
  }

  onActivate(data) {
    console.log("data from activation: ", data);
    this.hiveStats = data.data;
    const hive = new OpenHive(335, 170, this.hiveStats);
    this.hive = hive;
    this.camera.zoom = 4;
    this.add(this.player);

    this.add(this.hive);
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.style.display = "flex";
    this.harvestMenu = document.getElementById("harvest-menu");
    console.log("harvestMenu: ", this.harvestMenu);
    this.harvestMenu.style.display = "block";
    this.harvestMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
    
    ${showHarvestMenu(0)}
    `;
  }
  onDeactivate() {
    this.selected = null;
    this.activeItem = 0;
    this.hive.kill();
  }
  onPreUpdate() {
    if (!this.playerAnim) {
      this.player.doAnim("leftIdleBobble");
    } else {
      this.player.doAnim("harvestBox");
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      console.log("pressed x should go back");
      //go back
      this.harvestMenu.style.display = "none";
      this.menuContainer.style.display = "none";
      this.selected = null;
      this.activeItem = 0;
      goToScene("hiveMenu", this.hiveStats);
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play();
      if (this.activeItem === this.menuItems - 1) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play();
      if (this.activeItem === 0) {
        this.activeItem = this.menuItems - 1;
      } else {
        this.activeItem = this.activeItem - 1;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      let inventory = inventoryState.getInventory();
      if (this.activeItem === 0) {
        //harvest 1 box
        if (
          this.hiveStats.overallFrames.count -
            this.hiveStats.overallFrames.queenAccess >
          0
        ) {
          console.log("HARVEST: pressed enter harvest 1");
          this.hive.kill();
          this.hive = new OpenHive(335, 170, this.hiveStats);
          this.add(this.hive);
          this.setPlayerAnim(true);

          harvestBox(this.hiveStats);
        } else {
          Resources.Error.play();
          sendAlert("No Honey Boxes On Hive");
        }
      } else {
        //harvest all
        if (
          this.hiveStats.overallFrames.count -
            this.hiveStats.overallFrames.queenAccess >
          0
        ) {
          console.log("HARVEST: pressed enter harvest all");
          this.hive.kill();
          this.hive = new OpenHive(335, 170, this.hiveStats);
          this.add(this.hive);
          harvestAllBoxes(this.hiveStats);
          this.setPlayerAnim(true);
        } else {
          Resources.Error.play();
          sendAlert("No Honey Boxes On Hive");
        }
      }
    }
    this.harvestMenu.innerHTML = `<h1>Hive: ${
      this.hiveStats.id
    }</h1>${showHarvestMenu(this.activeItem)}`;
  }
}
function showHarvestMenu(active) {
  if (active === 0) {
    return `<h3>Harvest Box</h3><ul>
        <li id="list0"><span id="selector">></span>Harvest 1 Box</li>
        <li id="list1">Harvest All Supers</li>
      
      </ul>`;
  } else {
    return `<h3>Harvest Box</h3><ul>
        <li id="list0">Harvest 1 Box</li>
        <li id="list1"><span id="selector">></span>Harvest All Supers</li>
      
      </ul>`;
  }
}

function harvestBox(hiveStats) {
  console.log("HARVEST: inside harvestBox");
  let inventory = inventoryState.getInventory();
  let toHarvest = 0;
  if (
    inventory.harvestedHoney == undefined ||
    inventory.harvestedHoney == null
  ) {
    inventory.harvestedHoney = 0;
  }
  if (hiveStats.honeyFrames.count >= 10) {
    console.log("harvestBox: full box");
    toHarvest = 10;
    hiveStats.honeyFrames.count = hiveStats.honeyFrames.count - 10;
  } else {
    console.log("harvestBox: partial box");
    toHarvest = hiveStats.honeyFrames.count;
    hiveStats.honeyFrames.count = 0;
  }
  hiveStats.overallFrames.count = hiveStats.overallFrames.count - 10;
  hiveStats.overallFrames.boxes = hiveStats.overallFrames.boxes - 1;
  let honey = inventory.harvestedHoney + toHarvest;
  inventory.harvestedHoney = honey;
  inventory.boxes = inventory.boxes + 1;
  let hives = hiveState.getHives();
  let newHives = [];
  hives.forEach((hive, i) => {
    if (hive.birth == hiveStats.birth) {
      newHives.push(hiveStats);
    } else {
      newHives.push(hive);
    }
  });
  hiveState.setHives(newHives);
  toHarvest = parseFloat(toHarvest).toFixed(2);
  let text = toHarvest + " Honey Frames";

  Resources.PullFrame.play();
  if (toHarvest > 0) {
    Resources.Won.play();
    addExperience(Math.floor(toHarvest / 5));
    createGainedItem(`Experience + ${Math.floor(toHarvest / 5)}`);
    checkFirstHarvest();
    checkHarvestFrameAmount();
  }

  createGainedItem(text);
}

function harvestAllBoxes(hiveStats) {
  let boxesToRemove =
    (hiveStats.overallFrames.count - hiveStats.overallFrames.queenAccess) / 10;
  let inventory = inventoryState.getInventory();
  let toHarvest = hiveStats.honeyFrames.count;
  console.log(
    "HARVEST: all, to remove, ",
    boxesToRemove,
    " toHarvest: ",
    toHarvest
  );
  if (
    inventory.harvestedHoney == undefined ||
    inventory.harvestedHoney == null
  ) {
    inventory.harvestedHoney = 0;
  }
  inventory.harvestedHoney = inventory.harvestedHoney + toHarvest;
  inventory.boxes = inventory.boxes + boxesToRemove;
  hiveStats.overallFrames.boxes = hiveStats.overallFrames.boxes - boxesToRemove;
  hiveStats.overallFrames.count =
    hiveStats.overallFrames.count - boxesToRemove * 10;
  hiveStats.honeyFrames.count = 0;
  toHarvest = parseFloat(toHarvest).toFixed(2);
  let gainedText = toHarvest + " Honey Frames";
  let hives = hiveState.getHives();
  let newHives = [];
  hives.forEach((hive, i) => {
    if (hive.birth == hiveStats.birth) {
      newHives.push(hiveStats);
    } else {
      newHives.push(hive);
    }
  });
  hiveState.setHives(newHives);
  Resources.PullFrame.play();
  if (toHarvest > 0) {
    Resources.Won.play();
    addExperience(Math.floor(toHarvest / 5));
    createGainedItem(`Experience + ${Math.floor(toHarvest / 5)}`);
    checkFirstHarvest();
    checkHarvestFrameAmount();
  }

  createGainedItem(gainedText);
}
